import React from "react";
import { useHistory, Route, Redirect } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import Index from "../views/Index"
import UserProfile from 'views/examples/Profile'
import EditProfile from 'views/examples/EditProfile'
import UsersTable from 'views/examples/UsersTable'
import EditSchedule from "views/examples/EditSchedule";
import EditUserFull from "views/examples/EditUserFull";
//import Payroll from "views/examples/admin/Payroll";
import MainPayroll from "views/examples/schedule/MainPayroll";
import Accommodation from "views/examples/admin/accommodation/Accommodation.js"
import VillaRentals from "views/examples/admin/villaRentals/VillaRentals.js"
import Events from 'views/examples/ticketing/Events'
import EventsReports from 'views/examples/ticketing/EventsReports'
import ReportComissionByEvents from 'views/examples/ticketing/ReportComissonByEvents'
import EventsCart from 'views/examples/ticketing/EventsCart'
import TicketShop from 'views/examples/ticketing/TicketShop'
import CheckPermission from 'variables/CheckPermission'
import EventSales from "views/examples/ticketing/EventSales";
import NewPass from "components/Reusable Components/NewPass"
import VipReports from 'views/examples/ticketing/VipReports'
import WhatsApp from 'views/examples/whatsApp/WhatsApp'
import ReportAllTimeSales from 'views/examples/ticketing/ReportAllTimeSales'
import MainShop from "views/examples/merchShop/MainShop";
import AddProduct from "views/examples/merchShop/AddProduct";
import CashUp from "views/examples/merchShop/CashUp";
import Reports from "views/examples/merchShop/Reports";
import Stats from "views/examples/ticketing/Stats";
import AutomationMain from "views/examples/automation/AutomationMain";
import ReportTable from "views/examples/ticketing/ReportTable";
import EventsMedia from "views/examples/ticketing/EventsMedia";
import SellerPermissions from "views/examples/ticketing/SellerPermissions";
import ManualTimeClock from "views/examples/schedule/ManualTimeClock";
import MainSchedule from "views/examples/schedule/MainSchedule";
import CreateNewUser from "views/examples/CreateNewUser";
import NiceReport from "views/examples/ticketing/NiceReport";
import EmpTable from "views/examples/admin/EmpTable";
import OnlineSalesByDateReport from "views/examples/ticketing/OnlineSalesByDateReport";
import NewEventSales from "views/examples/ticketing/newTicketSales/NewEventSales";

const Admin =  (props)=>{
  const history = useHistory();

    if(!CheckPermission()){         //check role permission
        return <Redirect to="/" />
      }
  
  let Comp;
  let path = history.location.pathname;
  // eslint-disable-next-line
  switch(path){
        case "/admin":
          Comp=Index;
          break;
        case "/admin/index":
          Comp=Index;
          break;
        case "/admin/profile":
          Comp=UserProfile;
          break;
        case "/admin/user-profile":
          Comp=EditProfile;
          break; 
        case "/admin/edit-profile":
          Comp=EditProfile;
          break; 
        case "/admin/profile/edit":
          Comp=EditProfile;
          break; 
        case "/admin/newpass":
          Comp=NewPass;
          break; 
        case "/admin/users":
          Comp=UsersTable;
          break; 
        case "/admin/editschedule":
          Comp=MainSchedule;
          break; 
        case "/admin/edituserfull":
          Comp=EditUserFull;
          break;
        case "/admin/payroll":
         Comp=MainPayroll;
         break;
        case "/admin/accommodation":
          Comp=Accommodation;
          break;
        case "/admin/rentals":
          Comp=VillaRentals;
          break;
        case "/admin/events":
          Comp=Events;
          break;
        case "/admin/events/reports":
          Comp=EventsReports;
          break;
        case "/admin/events/reportsbyevent":
          Comp=ReportComissionByEvents;
          break;
        case "/admin/events/cart":
          Comp=EventsCart;
          break;
        case "/admin/events/media":
          Comp=EventsMedia;
          break;
        case "/admin/events/shop":
          Comp=TicketShop;
          break;
        case "/admin/events/reportsales":
          Comp=EventSales;
          break;
        case "/admin/events/newreportsales":
          Comp=NewEventSales;
          break;
        case "/admin/events/reports/vip":
          Comp=VipReports;
          break;
        case "/admin/events/nicereport":
          Comp=NiceReport;
          break;
        case "/admin/events/reports/bestsellers":
          Comp=ReportAllTimeSales;
          break;
        case "/admin/events/report/stats":
          Comp=Stats;
          break;
        case "/admin/events/report/table":
            Comp=ReportTable;
            break;
          case "/admin/events/permissions":
            Comp=SellerPermissions;
            break;
        case "/admin/whatsapp":
          Comp=WhatsApp;
          break;
        case "/admin/shop":
          Comp=MainShop;
          break;
        case "/admin/shop/addproduct":
          Comp=AddProduct;
          break;
        case "/admin/shop/cashup":
          Comp=CashUp;
          break;
        case "/admin/shop/reports":
          Comp=Reports;
          break;
        case "/admin/automation":
          Comp=AutomationMain;
          break;
        case "/admin/clockin":
          Comp=ManualTimeClock;
          break;
        case "/admin/new/user":
          Comp=CreateNewUser;
          break;
        case "/admin/employee/table":
          Comp=EmpTable;
          break;
        case "/admin/events/reports/online/sales":
          Comp=OnlineSalesByDateReport;
          break;
  }

    return <>
        <Sidebar
          
          logo={{
            innerLink: "/admin/index",
            imgSrc: require("assets/img/brand/argon-react.png").default,
            imgAlt: "..."
          }}
        />
        <div className="main-content">
          <AdminNavbar
            
            brandText="Celebrationjump LDA"
          />
          <Route
              component={Comp}
              />
          <Container fluid>
          </Container>
          <AdminFooter />
        </div>
        
      </>
    
  
}

export default Admin;
